class Document {
    constructor({ id, name, language, selectedPages, links, pageModels, convertedName, deletedAt = null }) {
        this._id = id;
        this._name = name;
        this._language = language;
        this._selectedPages = selectedPages;
        this._links = links;
        this._pageModels = pageModels;
        this._convertedName = convertedName;
        this._deletedAt = deletedAt;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    get language() {
        return this._language;
    }

    get selectedPages() {
        return this._selectedPages;
    }

    get links() {
        return this._links;
    }

    set pageModels(pageModels) {
        pageModels.map(model => {
            model.selected = this._selectedPages.indexOf(model.pageNumber) !== -1;
            return model;
        });
        this._pageModels = pageModels;
    }

    get pageModels() {
        return this._pageModels;
    }

    get convertedName() {
        return this._convertedName;
    }

    get deletedAt() {
        return this._deletedAt;
    }
}

export default Document;
